"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncCacheMap = exports.CacheMap = exports.AbstractCacheMap = exports.AbstractCacheKey = void 0;
class AbstractCacheKey {
}
exports.AbstractCacheKey = AbstractCacheKey;
class AbstractCacheMap {
    constructor() {
        this.map = new Map();
    }
    keyToCacheId(k) {
        if (k instanceof AbstractCacheKey) {
            return k.asCacheId();
        }
        return k;
    }
    has(k) {
        return this.map.has(this.keyToCacheId(k));
    }
    set(k, v) {
        return this.map.set(this.keyToCacheId(k), v);
    }
    delete(k) {
        return this.map.delete(this.keyToCacheId(k));
    }
}
exports.AbstractCacheMap = AbstractCacheMap;
class CacheMap extends AbstractCacheMap {
    constructor(factory) {
        super();
        this.factory = factory;
    }
    get(k) {
        const key = this.keyToCacheId(k);
        if (this.map.has(key)) {
            return this.map.get(key);
        }
        const v = this.factory(k);
        this.map.set(key, v);
        return v;
    }
}
exports.CacheMap = CacheMap;
class AsyncCacheMap extends AbstractCacheMap {
    constructor(factory) {
        super();
        this.factory = factory;
    }
    async get(k) {
        const key = this.keyToCacheId(k);
        if (this.map.has(key)) {
            return this.map.get(key);
        }
        const v = await this.factory(k);
        this.map.set(key, v);
        return v;
    }
}
exports.AsyncCacheMap = AsyncCacheMap;
//# sourceMappingURL=cache-map.js.map